"use client";
import { jsx as d } from "react/jsx-runtime";
import { JUSTIFIED_GALLERY_DEFAULT_HEIGHTS as j } from "./constants.mjs";
import { useJustifiedGalleryLayout as w } from "./useJustifiedGalleryLayout.mjs";
import { getItemRenderData as G, getItemStyleProps as J, getGapStyle as T } from "./utils.mjs";
import { Skeleton as _ } from "../../atoms/Skeleton/Skeleton.mjs";
import { cn as r } from "../../../utils/utils.mjs";
const z = ({
  items: t,
  responsiveHeights: l = j,
  rowGapPx: y = 8,
  columnGapPx: x = 8,
  className: u,
  children: I,
  lastRowStretchThreshold: S = 0.9,
  isLoading: $ = !1,
  skeletonProps: a,
  ...h
}) => {
  const { rows: L, lastRowIndex: R, shouldLastRowStretch: D, containerRef: E } = w({
    items: t,
    responsiveHeights: l,
    lastRowStretchThreshold: S,
    rowGapPx: y,
    columnGapPx: x
  });
  return /* @__PURE__ */ d(
    "div",
    {
      ref: E,
      "data-testid": "justified-gallery",
      className: r("flex flex-wrap @container/gallery", u),
      style: {
        gap: T(y, x),
        "--h-sm": `${l == null ? void 0 : l.sm}px`,
        "--h-md": `${l == null ? void 0 : l.md}px`,
        "--h-lg": `${l == null ? void 0 : l.lg}px`,
        "--h-xl": `${l == null ? void 0 : l.xl}px`
      },
      ...h,
      children: t.map((m, N) => {
        const f = G(m, N, L, R, D), c = J(f);
        return $ ? /* @__PURE__ */ d(
          _,
          {
            "data-testid": `skeleton-loader-${m.id}`,
            animation: "shimmer",
            ...a,
            className: r(
              "h-(--h-sm) @min-[768px]/gallery:h-(--h-md) @min-[1024px]/gallery:h-(--h-lg) @min-[1800px]/gallery:h-(--h-xl)",
              a == null ? void 0 : a.className
            ),
            style: { ...a == null ? void 0 : a.style, ...c }
          },
          m.id
        ) : /* @__PURE__ */ d(
          "div",
          {
            "data-testid": `justified-gallery-item-${m.id}`,
            className: "h-(--h-sm) @min-[768px]/gallery:h-(--h-md) @min-[1024px]/gallery:h-(--h-lg) @min-[1800px]/gallery:h-(--h-xl)",
            style: c,
            children: I(f)
          },
          m.id
        );
      })
    }
  );
};
export {
  z as JustifiedGallery
};
